import { render, staticRenderFns } from "./EmailConfigurationAdd.vue?vue&type=template&id=52d89c55&"
import script from "./EmailConfigurationAdd.vue?vue&type=script&lang=js&"
export * from "./EmailConfigurationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports